import * as actionTypes from 'store/actions/actionTypes';
import { updateObject } from 'utils/utility';

const initialState = {
  loading: true,
  error: null,
  formInitData: {},
  submitted: false,
  formSubmitting: false,
  formError: null,
};

const submitRequestCreateStart = state => {
  return updateObject(state, { formError: null, formSubmitting: true });
};

const submitRequestCreateSuccess = state => {
  return updateObject(state, {
    formError: null,
    formSubmitting: false,
    submitted: true,
  });
};

const submitRequestCreateFail = (state, action) => {
  return updateObject(state, {
    formError: action.error,
    formSubmitting: false,
  });
};

const initFormStart = state => {
  return updateObject(state, { loading: true, error: null });
};

const initFormSuccess = (state, action) => {
  return updateObject(state, { loading: false, formInitData: action.data });
};

const initFormFail = (state, action) => {
  return updateObject(state, { loading: false, error: action.error });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_REQUEST_CREATE_START:
      return submitRequestCreateStart(state);
    case actionTypes.SUBMIT_REQUEST_CREATE_SUCCESS:
      return submitRequestCreateSuccess(state);
    case actionTypes.SUBMIT_REQUEST_CREATE_FAIL:
      return submitRequestCreateFail(state, action);
    case actionTypes.INIT_FORM_START:
      return initFormStart(state);
    case actionTypes.INIT_FORM_SUCCESS:
      return initFormSuccess(state, action);
    case actionTypes.INIT_FORM_FAIL:
      return initFormFail(state, action);
    case '@@router/LOCATION_CHANGE':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
